import { render, staticRenderFns } from "./PackageKidsApprovedKidDialog.vue?vue&type=template&id=bffb3c88&scoped=true"
import script from "./PackageKidsApprovedKidDialog.vue?vue&type=script&lang=js"
export * from "./PackageKidsApprovedKidDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageKidsApprovedKidDialog.vue?vue&type=style&index=0&id=bffb3c88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffb3c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bffb3c88')) {
      api.createRecord('bffb3c88', component.options)
    } else {
      api.reload('bffb3c88', component.options)
    }
    module.hot.accept("./PackageKidsApprovedKidDialog.vue?vue&type=template&id=bffb3c88&scoped=true", function () {
      api.rerender('bffb3c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidsApprovedKidDialog.vue"
export default component.exports